module.exports = __webpack_public_path__ + "static/media/andressbarnes.c35075e3.jpg";